
<template>
  <div class="self-check-target card-display">
    <item-display
      v-bind:item="item"
      v-bind:showing="showing"
    ></item-display>

    <div class="button-container">
      <button v-on:click="doFailure" tabindex=1>👎</button>
      <button v-on:click="doSuccess" tabindex=2>👍</button>
    </div>
  </div>
</template>

<script>
import EventBus from '@/libs/EventBus.js';
import ItemDisplay from '@/components/ItemDisplay.vue';

export default {
  props: ['item', 'showing'],
  methods: {
    doSuccess: function () {
      EventBus.$emit('response-event', true);
    },
    doFailure: function () {
      EventBus.$emit('response-event', false);
    },
  },
  components: {
    ItemDisplay,
  },
};
</script>